/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export class ProjectParameterInfo {
  projectParameterName: string;
  categorySet: string;
  parameterCategory: string;
  parameterGroup: string;
  grouping: string;
  isShared: boolean;
}
